import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../../common/Text';
import IconButton from '../../../common2/IconButton';

import ArrowLeftIcon from '../../../../icons/arrow-left.svg';
import ArrowRightIcon from '../../../../icons/arrow-right.svg';

import styles from './DocumentsNavigation.scss';

type Props = {
  current: number;
  total: number;
  onPrevButtonClick: (next: number) => void;
  onNextButtonClick: (prev: number) => void;
};

function DocumentsNavigation(props: Props) {
  const { current, total, onPrevButtonClick, onNextButtonClick } = props;
  const { t } = useTranslation();

  const handlePrevButtonClick = useCallback(() => {
    onPrevButtonClick((current - 1 + total) % total);
  }, [onPrevButtonClick]);

  const handleNextButtonClick = useCallback(() => {
    onNextButtonClick((current + 1) % total);
  }, [onPrevButtonClick]);

  return (
    <div className={styles.container}>
      <IconButton
        icon={ArrowLeftIcon}
        ariaLabel="Previous document"
        disabled={total === 1}
        onClick={handlePrevButtonClick}
      />
      <Text className={styles.counter}>{t('POSITION_INDICATOR', { current: current + 1, total })}</Text>
      <IconButton
        icon={ArrowRightIcon}
        ariaLabel="Next document"
        disabled={total === 1}
        onClick={handleNextButtonClick}
      />
    </div>
  );
}

export default React.memo(DocumentsNavigation);
